import React from 'react';

import { AboutUs, Footer, Gallery, Header, Experience, Laurels, SpecialMenu,  } from './container';
import { Navbar } from './components';
import './App.css';

import ChatBot from './container/ChatBot/ChatBot';

const App = () => (
  <div>
    <Navbar />
    <Header />
    <AboutUs />
    <Gallery />
    <Experience />
    {/* <SpecialMenu /> */}
    <Laurels />
    <Footer />
    {/* <ChatBot/> */}
  </div>
);

export default App;
